import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      minHeight: "94vh",
      maxHeight: "98vh",
      minWidth: "98%",
      maxWidth: "90%",
    },
    "& + .pac-container": {
      zIndex: theme.zIndex.modal + 1
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: theme.palette.custom.main,
      color: "#fff",
      padding: "8px 10px",
    },
    "& .MuiDialogTitle-root+.MuiDialogContent-root ": {
      paddingTop: 0,
    },
    "& .MuiDialogContent-root": {
      padding: "20px 10px",
    },
    "& .MuiDialogActions-root": {
      paddingInlineEnd: 24,
    },
  },
  carouseltext:{
paddingTop:"20px"
  },
  estimatedcarousel:{
   paddingBottom:1,
   borderRadius:"5px",
   width:"95%",
   height:"100px",
   marginLeft:"3% !important",
  boxShadow:"6px 6px 8px 6px rgb(43 43 45 / 14%) !important"
  },
  Carouselcontainer:{
    padding:"15px 5px",
    alignItems: "center",

   },
   carouselimages:{
    width : "100px"
  },
  Carouselgrids:{
  textAlign:"center"
  },
  Carouselcontent:{
    color: "black",
    fontSize: "12px !important",
    display: "flex",
    alignItems: "flex-end",
  },
}));

export default useStyles;
